<div class="attempt-limit-container h-100 d-flex flex-column">
    <common-header></common-header>
    <main class="container-fluid px-0 d-flex align-items-center justify-content-center">
        <div class="wrapper">
            <div class="attempt-msg-container text-center">
                <h1 class="heading">{{ 'SHARED.ATTEMPTS_EXCEEDED.ATTEMPT_LIMIT_MSG1' | translate }}</h1>
                <p *ngIf="isAttNoWithinTransformLimit" class="attempt-msg mb-2">{{ 'SHARED.ATTEMPTS_EXCEEDED.ATTEMPT_LIMIT_MSG2' + ((attemptLimitNumber || 0) | i18nPlural: pluralMapping) | translate : {
                    attemptAllowed : attemptLimit} }}</p>
                <p *ngIf="!isAttNoWithinTransformLimit" class="attempt-msg mb-2">{{ 'SHARED.ATTEMPTS_EXCEEDED.ATTEMPT_LIMIT_MSG3' | translate }}</p>
                <a *ngIf="userData && userData.launchType != 'lti'" class="btn py-3" href="javascript:void(0)" (click)="navigateToDashboard()">{{
                    'SHARED.ATTEMPTS_EXCEEDED.NAVIGATE_TO_DASHBOARD_BUTTON' | translate }}</a>
            </div>
        </div>
    </main>
    <footer></footer>
</div>